const STRINGS = {
  completionMessage: "Time's up!"
};
export default STRINGS;